import Link from "next/link";
import "./Footer.css";
import { SITE_NAME_UPPER } from "@/constants/site";


export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <nav className="footer-nav">
          <Link href="/MentionsLegales" className="nav-link">Mentions Légales</Link>
          <Link href="/CGV" className="nav-link">Conditions Générales de Ventes</Link>
          <Link href="/PlanSite" className="nav-link">Plan du site</Link>
        </nav>
       
        <p className="copyright">Copyright © 2025 {SITE_NAME_UPPER} - Tous droits réservés</p>
      </div>
    </footer>
  );
}